@if (withShell) {
  <astral-field-shell [control]="control" [forId]="resolvedInputId" [helpText]="helpText">
    <div class="astral-select__layout" [class.astral-select__layout--with-supplemental-label]="!!resolvedSupplementalLabel">
      <ng-container [ngTemplateOutlet]="selectTemplate"></ng-container>
      <ng-container [ngTemplateOutlet]="supplementalLabelTemplate"></ng-container>
    </div>
  </astral-field-shell>
} @else {
  <div class="astral-select__layout" [class.astral-select__layout--with-supplemental-label]="!!resolvedSupplementalLabel">
    <ng-container [ngTemplateOutlet]="selectTemplate"></ng-container>
    <ng-container [ngTemplateOutlet]="supplementalLabelTemplate"></ng-container>
  </div>
}

<ng-template #selectTemplate>
  <div
    class="astral-select"
    [class.astral-select--readonly]="control?.isReadonly"
    [class.astral-select--disabled]="resolvedDisabled"
    [class.astral-select--focused]="isFocused"
    [class.astral-select--open]="isOpen"
  >
    <div class="astral-select__actions">
      @if (showClearOthers) {
        <astral-field-action
          icon="clearOthers"
          titleKey="COMMON.CLEAR_OTHER_FILTERS"
          ariaLabelKey="COMMON.CLEAR_OTHER_FILTERS"
          (click)="clearAllOtherInputs()"
        ></astral-field-action>
      }

      @if (showClearThis) {
        <astral-field-action
          icon="clear"
          titleKey="COMMON.CLEAR"
          ariaLabelKey="COMMON.CLEAR"
          (click)="clearInput()"
        ></astral-field-action>
      }
    </div>

    <div cdkOverlayOrigin #overlayOrigin="cdkOverlayOrigin" #controlShell class="astral-select__control-shell">
      <button
        #trigger
        astralFieldAccessibility
        type="button"
        class="astral-select__trigger"
        role="combobox"
        aria-autocomplete="none"
        [astralFieldControl]="control"
        [astralFieldHelpText]="helpText"
        [astralFieldInputId]="resolvedInputId"
        [attr.id]="resolvedInputId"
        [attr.name]="resolvedInputName"
        [attr.aria-controls]="resolvedInputId + '-panel'"
        [attr.aria-activedescendant]="activeOptionId"
        [attr.aria-expanded]="isOpen ? 'true' : 'false'"
        aria-haspopup="listbox"
        [disabled]="resolvedDisabled ? true : null"
        (click)="togglePanel()"
        (keydown)="handleTriggerKeydown($event)"
        (focus)="handleFocus()"
        (blur)="handleBlur()"
      >
        @if (control?.isReadonly) {
          <span class="astral-select__trigger-icon" aria-hidden="true">
            <i [class]="readonlyIconClass"></i>
          </span>
        }
        @if (selectedItemIcon) {
          <span class="astral-select__trigger-icon" aria-hidden="true">
            @if (getIconSrc(selectedItemIcon)) {
              <img [src]="getIconSrc(selectedItemIcon)!" alt="" />
            } @else if (getIconClass(selectedItemIcon)) {
              <i [class]="getIconClass(selectedItemIcon)"></i>
            }
          </span>
        }
        <span class="astral-select__trigger-label" [class.astral-select__trigger-label--placeholder]="displaysPlaceholder">
          @if (multiple && selectedItems.length) {
            @for (item of selectedItems; track trackItem($index, item); let isLast = $last) {
              {{ item.name | translate }}@if (!isLast) {<span>, </span>}
            }
          } @else {
            {{ triggerLabel | translate }}
          }
        </span>
      </button>
    </div>
  </div>
</ng-template>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayPush]="false"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayViewportMargin]="overlayViewportMargin"
  (overlayOutsideClick)="handleOverlayOutsideClick($event)"
  (positionChange)="handleOverlayPositionChange($event)"
>
  <div
    #panel
    class="astral-select__panel"
    [class.astral-select__panel--above]="isPanelAbove"
    [style.max-height.px]="panelMaxHeight"
    [attr.id]="resolvedInputId + '-panel'"
    role="listbox"
    [attr.aria-labelledby]="resolvedInputId"
    [attr.aria-multiselectable]="multiple ? 'true' : null"
  >
    @if (!hasOptions) {
      <button type="button" class="astral-select__option astral-select__option--empty" disabled>
        {{ resolvedNoOptionsPlaceholderText | translate }}
      </button>
    }

    @for (item of resolvedItemsSource; track trackItem($index, item); let index = $index) {
      <button
        #optionButton
        type="button"
        class="astral-select__option"
        role="option"
        [attr.id]="optionId(index)"
        [attr.tabindex]="-1"
        [class.astral-select__option--active]="index === activeOptionIndex"
        [class.astral-select__option--selected]="isSelected(item)"
        [attr.aria-selected]="isSelected(item)"
        [disabled]="item.disabled ? true : null"
        (click)="selectItem(item)"
      >
        @if (multiple) {
          <span class="astral-select__option-icon" aria-hidden="true">
            <i [class]="getSelectionIconClass(item)"></i>
          </span>
        }
        @if (item.icon) {
          <span class="astral-select__option-icon" aria-hidden="true">
            @if (getIconSrc(item.icon)) {
              <img [src]="getIconSrc(item.icon)!" alt="" />
            } @else if (getIconClass(item.icon)) {
              <i [class]="getIconClass(item.icon)"></i>
            }
          </span>
        }
        {{ item.name | translate }}
      </button>
    }
  </div>
</ng-template>

<ng-template #supplementalLabelTemplate>
  @if (resolvedSupplementalLabel) {
    <span class="astral-select__supplemental-label">
      {{ resolvedSupplementalLabel | translate }}
    </span>
  }
</ng-template>
